module.exports = __webpack_public_path__ + "img/addresele.feb411e7.png";